const PRICE_DETAILS_TRIGGER = 'priceDetails';
const TYPED_PRICES_TRIGGER = 'typedPrices';
const ARRAY_INDICATOR = 'items';
export const splitArrayAtItem = (arr, splitter) => {
    const index = arr.indexOf(splitter);
    if (index === -1)
        return [arr, []];
    return [arr.slice(0, index), arr.slice(index + 1)];
};
export function getLabelFromScsData(label, vehicle) {
    if (!label || !vehicle)
        return '';
    if (!label.startsWith(PRICE_DETAILS_TRIGGER))
        return label;
    const labelParts = label.split(' ');
    const path = labelParts.shift();
    const pathArray = path === null || path === void 0 ? void 0 : path.split('.');
    const dynamicLabel = getPropertyByPath(pathArray, vehicle);
    return `${dynamicLabel} ${labelParts.join(' ')}`.trim();
}
export function getPriceFootnote(footnote, vehicle) {
    if (!footnote || !vehicle)
        return '';
    const dynamicPart = getPlaceholder(footnote);
    if (!dynamicPart)
        return footnote;
    const pathArray = dynamicPart.split('.');
    const propertyFromScs = getPropertyByPath(pathArray, vehicle);
    return replacePlaceholder(footnote, dynamicPart, propertyFromScs);
}
export function getPropertyByPath(pathComponents, obj) {
    return pathComponents.reduce((acc, part) => acc === null || acc === void 0 ? void 0 : acc[part], obj);
}
export function getPlaceholder(str) {
    if (!str)
        return null;
    const match = str === null || str === void 0 ? void 0 : str.match(/{{(.*?)}}/);
    return match ? match[1] : null;
}
export function replacePlaceholder(str, placeholderName, replacement) {
    const pattern = new RegExp(`{{${placeholderName}}}`);
    return str.replace(pattern, replacement);
}
export const getTypedPrice = (pathComponents, vehicle) => {
    var _a, _b, _c, _d;
    if (!pathComponents || (pathComponents === null || pathComponents === void 0 ? void 0 : pathComponents.length) > 2 || !vehicle)
        return '';
    const priceType = pathComponents[0];
    const nameText = pathComponents[1];
    if (priceType && !nameText) {
        return (_b = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.typedPrices) === null || _a === void 0 ? void 0 : _a.find((price) => price.type === priceType)) === null || _b === void 0 ? void 0 : _b.formatted;
    }
    if (priceType && nameText) {
        return (_d = (_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.typedPrices) === null || _c === void 0 ? void 0 : _c.find((price) => price.type === priceType && price.nameText === nameText)) === null || _d === void 0 ? void 0 : _d.formatted;
    }
    return '';
};
export const getPriceComponent = (pathComponents, vehicle) => {
    if (!pathComponents || !vehicle)
        return null;
    const [basePath, arrayPath] = splitArrayAtItem(pathComponents, ARRAY_INDICATOR);
    if (arrayPath.length === 0)
        return getPropertyByPath(basePath, vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceDetails);
    if (arrayPath.length > 0) {
        const propsByPath = getPropertyByPath(basePath, vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceDetails);
        if (typeof propsByPath !== 'undefined') {
            const items = propsByPath[ARRAY_INDICATOR];
            if (!Array.isArray(items))
                return null;
            const key = arrayPath[0];
            const prop = arrayPath[1];
            const item = items.find((it) => it.key === key);
            if (typeof item !== 'undefined') {
                return item[prop] || null;
            }
        }
    }
    return null;
};
export const pricePropertyLookUp = (path, vehicle, logger) => {
    if (!path)
        return null;
    const pathComponents = path.split('.');
    if (pathComponents.length === 1)
        return null;
    const strategyTrigger = pathComponents.shift();
    switch (strategyTrigger) {
        case PRICE_DETAILS_TRIGGER:
            return getPriceComponent(pathComponents, vehicle);
        case TYPED_PRICES_TRIGGER:
            return getTypedPrice(pathComponents, vehicle);
        default:
            logger === null || logger === void 0 ? void 0 : logger.warn('### unknown property', strategyTrigger);
            return null;
    }
};
export const getPriceGroupsForVehicle = (priceConfiguration, vehicle) => {
    if (!priceConfiguration || !vehicle)
        return [];
    const availability = vehicle === null || vehicle === void 0 ? void 0 : vehicle.availableFromCode;
    const businessModel = vehicle === null || vehicle === void 0 ? void 0 : vehicle.businessModel.code;
    const group = priceConfiguration.find((config) => config.fields.businessModel === businessModel && config.fields.availability === availability);
    if (!group)
        return [];
    return group.fields.items.map((item) => item.fields);
};
export const mapSubPrices = (items, vehicle, logger) => {
    return items.map((fragment) => {
        const subPrice = fragment.fields;
        return {
            label: subPrice.label,
            path: subPrice.path,
            price: pricePropertyLookUp(subPrice.path, vehicle, logger),
            vatReclaimable: subPrice.vatReclaimable,
            suffix: subPrice.suffix,
        };
    });
};
export const mapPriceGroups = (items, vehicle, logger) => {
    return items.map((fragment) => {
        const priceGroupItem = fragment.fields;
        return {
            label: priceGroupItem.label.startsWith(PRICE_DETAILS_TRIGGER)
                ? getLabelFromScsData(priceGroupItem.label, vehicle)
                : priceGroupItem.label,
            path: priceGroupItem.path,
            priceFootnote: getPriceFootnote(priceGroupItem.priceFootnote, vehicle),
            price: pricePropertyLookUp(priceGroupItem.path, vehicle, logger),
            vatReclaimable: priceGroupItem.vatReclaimable,
            isBold: priceGroupItem.isBold,
            suffix: priceGroupItem.suffix,
            priceIncludeText: priceGroupItem.priceIncludeText,
            priceIncludeAriaLabel: priceGroupItem.priceIncludeAriaLabel,
            disclaimerText: priceGroupItem.disclaimerText,
            items: mapSubPrices(priceGroupItem.items, vehicle, logger),
        };
    });
};
export const mapContentFragmentDataToPriceConfig = (priceGroups, vehicle, logger) => {
    return priceGroups.map((group) => {
        return {
            label: group.label,
            items: mapPriceGroups(group.items, vehicle, logger),
        };
    });
};
export const usePriceConfiguration = (vehicle, priceConfiguration, logger) => {
    const priceGroupsForVehicle = getPriceGroupsForVehicle(priceConfiguration, vehicle);
    return mapContentFragmentDataToPriceConfig(priceGroupsForVehicle, vehicle, logger);
};
export const useMainPriceConfiguration = (vehicle, configurationCF, logger) => {
    var _a, _b;
    if (!vehicle || !configurationCF || configurationCF.length === 0)
        return [];
    const businessModel = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.businessModel) === null || _a === void 0 ? void 0 : _a.code;
    const availability = vehicle === null || vehicle === void 0 ? void 0 : vehicle.availableFromCode;
    const priceConfigFields = configurationCF.map((it) => it.fields);
    const relevantConfigurationItemsCFs = (_b = priceConfigFields === null || priceConfigFields === void 0 ? void 0 : priceConfigFields.find((it) => it.availability === availability && it.businessModel === businessModel)) === null || _b === void 0 ? void 0 : _b.items;
    const prices = relevantConfigurationItemsCFs === null || relevantConfigurationItemsCFs === void 0 ? void 0 : relevantConfigurationItemsCFs.map((item) => item.fields);
    const mappedPrices = prices === null || prices === void 0 ? void 0 : prices.map((price) => {
        var _a;
        const priceFootnotePlaceholder = getPlaceholder(price.priceFootnote);
        const priceFootnote = priceFootnotePlaceholder
            ? replacePlaceholder(price.priceFootnote, priceFootnotePlaceholder, pricePropertyLookUp(priceFootnotePlaceholder, vehicle, logger))
            : price.priceFootnote;
        const label = ((_a = price === null || price === void 0 ? void 0 : price.label) === null || _a === void 0 ? void 0 : _a.startsWith(PRICE_DETAILS_TRIGGER))
            ? pricePropertyLookUp(price.label, vehicle, logger)
            : price.label;
        return Object.assign(Object.assign({}, price), { price: pricePropertyLookUp(price.path, vehicle, logger), priceFootnote,
            label });
    });
    const forVatMatch = (it) => it.vatReclaimable === vehicle.vatReclaimable;
    const forNonEmptyPrice = (it) => Boolean(it.price);
    const filteredPrices = mappedPrices === null || mappedPrices === void 0 ? void 0 : mappedPrices.filter(forNonEmptyPrice).filter(forVatMatch);
    return filteredPrices;
};
